/**
 */

export default {
  isContains(str, substr) {
    return str.indexOf(substr) >= 0;
  },
  // 是否是汉字
  isChinese(val) {
    const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
    if (reg.test(val)) {
      return true;
    }
    return false;
  },
};
